__WIN32_CHECK = 1
__IOS_NOT_AUDIT = 0

isLocalDevelopMode = __DEBUG > 0
__WANBA = !isLocalDevelopMode
__HE    = isLocalDevelopMode

HALF_FRAME = 1

// let sys = cc.sys
// switch(sys.os) {
//     case sys.OS_IOS: __IOS = 1; break
//     case sys.OS_ANDROID: __ANDROID = 1; break
//     case sys.OS_WINDOWS: __WIN32 = 1; break
// }
// // TODO: faking
// __ANDROID = 0;
// __WIN32 = 1
// __IOS = 0
